module.exports = __webpack_public_path__ + "static/media/gold_industry.fc6580d5.svg";